import { BOYACA_MUNICIPALITIES } from "../data/BoyacaMunicipalities";
import { SimplifiedDocumentTypes } from "../data/SimplifiedDocumentTypes";

/**
 * Configuración personalizada de los formularios institucionales.
 *
 * Permite definir configuraciones específicas para determinadas instituciones
 * sin modificar la lógica general de los componentes de formulario.
 *
 * La configuración se organiza por institución y por tipo de formulario.
 * Dentro de cada formulario se pueden definir configuraciones específicas
 * para sus campos.
 * 
 */
const institutionalFormConfig = {
    red_bibliotecas_publicas_de_boyaca: {
        formMunicipality: {
            fields: {
                municipalities: {
                    options: BOYACA_MUNICIPALITIES
                },
                documentTypes: {
                    options: SimplifiedDocumentTypes
                }
            }
        }
    },
};

export default institutionalFormConfig;